export const initialFieldStates = {
    first_name: {value: "", error: false},
    last_name: {value: "", error: false},
    email: {value: "", error: false},
    date_of_birth: {value: null, error: false},
    street1: {value: "", error: false},
    street2: {value: "", error: false},
    city: {value: "", error: false},
    state: {value: "", error: false},
    zip_code: {value: "", error: false},
    residential_status: {value: "O", error: false},
    residential_date: {value: null, error: false},
    previous_street1: {value: "", error: false},
    previous_street2: {value: "", error: false},
    previous_city: {value: "", error: false},
    previous_state: {value: "", error: false},
    previous_zip_code: {value: "", error: false},
    previous_residential_years: {value: "", error: false},
    previous_residential_months: {value: "", error: false},
    employment_status: {value: "", error: false},
    yearly_income: {value: "", error: false},
    other_income_source: {value: "", error: false},
    other_income_gross_amount: {value: "", error: false},
    phone_number: {value: "", error: false},
    citizenship_status: {value: "", error: false},
    monthly_housing_payment: {value: "", error: false},
    employer_name: {value: "", error: false},
    employer_phone: {value: "", error: false},
    job_title: {value: "", error: false},
    employer_date: {value: null, error: false},
    previous_employment_status: {value: "", error: false},
    previous_employer_name: {value: "", error: false},
    previous_employer_years: {value: "", error: false},
    previous_employer_months: {value: "", error: false},
    previous_employer_phone: {value: "", error: false},
    previous_job_title: {value: "", error: false},
    social_security_number: {value: "", error: false},
    trade_in_intent: {value: 'No', error: false},
    coapplicant_intent: {value: false, error: false},
    relationship_to_primary: {value: "", error: false},
    reuse_primary_address: {value: false, error: false},
};
